import { useQuery } from '@tanstack/react-query';

import { getImport, listImports } from '../../lib/api/endpoints';

export const importKeys = {
  all: ['imports'] as const,
  account: (accountId: string | null) => ['imports', 'account', accountId] as const,
  detail: (id: string) => ['imports', id] as const,
};

export function useImports() {
  return useQuery({
    queryKey: importKeys.all,
    queryFn: listImports,
  });
}

export function useAccountImports(accountId: string | null) {
  return useQuery({
    queryKey: importKeys.all,
    queryFn: listImports,
    select: (imports) => imports.filter((importRecord) => importRecord.accountId === accountId),
    enabled: Boolean(accountId),
  });
}

export function useImportDetail(id: string | null) {
  return useQuery({
    queryKey: id ? importKeys.detail(id) : ['imports', 'empty'],
    queryFn: () => {
      if (!id) throw new Error('Import id is required.');
      return getImport(id, true);
    },
    enabled: Boolean(id),
  });
}
